import React, { Component } from 'react';


/**
 * @see /public/data.json
 */
class Card extends Component {

    render() {
        return (
            <>
                <div className="card">
                    <img src={this.props.art.images.banner} className="card-img-top" alt={this.props.art.title} loading="lazy" />
                    <div className="card-body">
                        {/* <h5 className="card-title">{this.props.art.title}</h5> */}
                        <p className="card-text">
                            {this.props.art.artist}<br />
                            <strong>{this.props.art.title}</strong>
                        </p>
                        <ul>
                            {/* <li className="text-muted">year: {this.props.art.year}</li> */}
                            <li className="text-muted">id: {this.props.art.id}</li>
                            <li>creation_year: {this.props.art.creation_year}</li>
                            <li>purchase_year: {this.props.art.purchase_year}</li>
                            {/* <li>artistBirthYear (period start): {this.props.art.artistBirthYear}</li> */}
                            {/* <li>artistDeathYear (period end): {this.props.art.artistDeathYear}</li> */}
                            <li>location: {this.props.art.location}</li>
                            <li>type (category?): {this.props.art.type}</li>
                            <li>theme: {this.props.art.theme}</li>
                            <li>period: {this.props.art.period}</li>
                            {/* <li className="text-muted"><b>dimensions:</b> {this.props.art.dimensions}</li> */}
                        </ul>
                        <a
                            href={this.props.art.url}
                            title={this.props.art.url}
                            className="btn btn-link"
                        >Show</a>
                    </div>
                </div>
            </>
        )
    }
}

export default Card;